import React from 'react'
// import classes from './styles.module.scss'
import { WhiteSpace } from 'antd-mobile'
import { openUri } from 'utils'
import _ from 'lodash'

export default class Banners extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  render() {
    const { siteConfig } = this.props
    const bannerList = _.chain(siteConfig).get('configContent.banners', []).value()
    if (_.size(bannerList)) {
      return (
        <React.Fragment>
          <WhiteSpace size='lg' />
          {bannerList.map((item) => (
            <img
              src={item.imgUrl}
              width='100%'
              key={item.imgUrl}
              onClick={() => {
                openUri(item.target)
              }}
            />
          ))}
        </React.Fragment>
      )
    }
    return null
  }
}
